import { styled } from '@mui/material';

import { confirmPopperIconColorMap } from './ConfirmPopperCDS.constants';

const placementStylesMap = {
  top: {
    marginBottom: '13px !important',
    '& [data-popper-arrow="true"]': {
      bottom: '-7px',
      '&::before': {
        transform: 'rotate(45deg)',
      },
    },
  },
  right: {
    marginLeft: '13px !important',
    '& [data-popper-arrow="true"]': {
      left: '-7px',
      '&::before': {
        transform: 'rotate(-45deg)',
      },
    },
  },
  bottom: {
    marginTop: '13px !important',
    '& [data-popper-arrow="true"]': {
      top: '-7px',
      '&::before': {
        transform: 'rotate(-135deg)',
      },
    },
  },
  left: {
    marginRight: '13px !important',
    '& [data-popper-arrow="true"]': {
      right: '-7px',
      '&::before': {
        transform: 'rotate(135deg)',
      },
    },
  },
};

export const getPopperStyles = ({ placement }) => ({
  zIndex: 1300,
  ...placementStylesMap[placement],
});

export const popperBodyStyles = {
  backgroundColor: ({ palette }) => palette.background.paper,
  padding: '12px',
  borderRadius: ({ shape }) => shape.radius.l,
  boxShadow: `0px 5px 12px 4px #12171D0D`,
};

export const getPopperContentStyles = ({ type }) => ({
  display: 'flex',
  gap: '4px',
  alignItems: 'flex-start',
  svg: {
    marginTop: '2px',
    color: confirmPopperIconColorMap[type],
  },
});

export const Arrow = styled('div')(({ theme }) => ({
  zIndex: 1300,

  '&,&::before': {
    width: '15px',
    height: '15px',
    position: 'absolute',
  },

  '&::before': {
    content: '""',
    transform: 'rotate(45deg)',
    backgroundColor: theme.palette.background.paper,
    borderBottomRightRadius: theme.shape.radius.s,
    top: 0,
    left: 0,
  },
}));

export const popperControlsStyles = {
  marginTop: '13px',
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};
